/* eslint-disable */

<template>
        <div class="d-flex pl-2" :key="edit">
            <v-container class="py-1 px-0">
                <v-row no-gutters>
                <v-col cols="10" class="d-flex align-start flex-grow-1 flex-shrink-0"> 
                    <span v-if="!edit" >
                        <b>{{ o_department.name }}</b> - 
                        <i>{{ o_department.desc }}</i><br/>
                        <i>Contatti: <span v-for="(_cid, dc_idx) in o_department.contacts" :key="dc_idx"><b>{{ address_book[_cid] }}</b><span v-if="dc_idx < (o_department.contacts.length-1)">, </span></span></i>
                    </span>
                    <v-form v-else v-model="valid">
                        <div class="d-flex" :key="edit">
                        <v-text-field dense outlined
                            v-model="c_department.name"
                            label="nome"
                            required
                            :rules="[rules.nameRules(c_department.name,2), rules.mandatory]"
                        ></v-text-field>    
                        <v-text-field dense outlined
                            class="pl-2"
                            label="note"
                            v-model="c_department.desc"
                        ></v-text-field>
                        <v-autocomplete dense outlined
                            class="pl-2"
                            label="contatti"
                            v-model="c_department.contacts"
                            :items="contacts"
                            item-text="name"
                            item-value="id"
                            multiple
                            small-chips
                        ></v-autocomplete>
                        </div>
                    </v-form>
                </v-col>
                <v-col cols="2" class="d-flex justify-end flex-shrink-1 flex-grow-0">
                    <span v-if="!edit">
                    <v-btn
                        color="action"
                        fab
                        class="ma-1" small
                        ><v-icon class="ma-2" @click.stop="updateDepartment">edit</v-icon></v-btn>
                    <v-btn
                        color="action"
                        fab
                        class="ma-1" small
                    ><v-icon class="ma-2" @click.stop="openDeleteDepartmentConfirm">delete</v-icon></v-btn>
                    </span>
                    <span v-else>
                        <v-btn
                            color="action"
                            fab
                            class="ma-1" small
                        ><v-icon class="ma-2" @click.stop="restoreDepartment">cancel</v-icon></v-btn>
                        <v-btn
                            color="action"
                            fab
                            class="ma-1" small
                            :disabled="!valid"
                        ><v-icon class="ma-2" @click.stop="saveDepartment">save</v-icon></v-btn>
                    </span>
                </v-col>
            </v-row>
            </v-container>

        <ConfirmDialog
            v-bind:data="delete_dialog.department"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onDeleteDepartmentConfirm"/>
        </div>
</template>
<script>
// import _ from 'lodash'
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import {f_rules} from '../../utils/commonUtils'
import { searchDesign } from "../../utils/dbUtility"

export default {
    components: {ConfirmDialog},
    props: [
        "o_department", "o_idx", "address_book", "new", "contacts", "loc_id"
    ],
    data(){
        return {
            valid: false,
            rules: f_rules,
            c_department: {},
            edit: false,
            delete_dialog: {
                department: {
                    dialog: false,
                    title: 'Elimina reparto',
                    message: "Sei sicuro di voler rimuovere il reparto selezionato?",
                    choices: [
                        {key: "cancel", val: "annulla", mod: "success"},
                        {key: "delete", val: "elimina"}
                        ]
                }
            }
        }
    },
    mounted() {
        this.c_department = _.cloneDeep(this.o_department)
        if (this.new) {
            this.edit = true
        }
    },
    watch: {
    },
    methods: {
        c_exists(v){ 
            console.log(v, Object.keys(this.address_book).indexOf(v))
            return Object.keys(this.address_book).indexOf(v)>=0
        },
        async updateDepartment() {
            this.edit = true
        },
        async isDeletable() {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'key', [this.loc_id, this.o_department.id], true)
            if (res.length > 0) {
                return res[0].value > 0 ? false : true
            } else {
                return true
            }
        },
        restoreDepartment(){
            if (this.new) {
                this.$emit('department_remove', this.c_department.id, this.o_idx)
            
            } else {
                this.c_department = _.cloneDeep(this.o_department)
            }
            this.edit = false
        },
        saveDepartment() {
            this.$emit('department_update', this.c_department, this.o_idx)
            this.edit = false
        },
        openDeleteDepartmentConfirm(){
            if (this.isDeletable()) {
                if (this.c_department.name && this.c_department.name.trim()!=''){
                    this.delete_dialog.department.message = `Sei sicuro di voler rimuovere ${this.c_department.name}?`
                } 
                this.delete_dialog.department.dialog = true;
            } else {
                this.$store.commit("showSnackbar", {text: "Reparto non cancellabile, sono presenti degli strumenti", color: 'error'})
            }
        },
        async onDeleteDepartmentConfirm(choice){
            if(choice == "delete"){
                this.$emit('department_remove', this.o_department.id, this.o_idx)
            }
            this.closeDialog()
        },
        closeDialog(){
            this.delete_dialog.department.dialog = false;
        }
    }
}

</script>